import React, { Component } from 'react';
import Section from "./Section.js";
import SubSection from "./SubSection.js";
import ListPicker from "./ListPicker";
import Actions from "../modules/actions";
import { connect } from "react-redux";
import { Grid, Typography } from '@material-ui/core';
import MyButton from "./MyButton";
import Link from "./Link";
import B from "./B";

const mapStateToProps = (state, ownProps) => {
  let facades = [];
  let facade = {};
  const building = state.buildings.find(b => b.buildingId === state.currentBuildingId);
  if(building) {
    facades = building.facades;
    facade = facades.find(f => f.facadeId === state.currentFacadeId);
  } else {
    // I should make this only throw if there are buildings and there is a current building selected...
    //throw new Error("could not find building");
  }
  return ({
    //lang: Language.isEnglish(state.lang) ? English : French,
    buildings: state.buildings || [],
    building,
    currentBuildingId: state.currentBuildingId, // should I pull this out of building for easier debugging?
    facades, // should I put the facades on the building object? -> no, facades should be an array of facade objects
    facade,
    // actually, that could work. I would call the the reducer for the facade inside of the reducer for the building. And, the reducer for the facade would call the reducer for the responses.
    currentFacadeId: state.currentFacadeId, // should I pull this out of facade for easier dubugging?
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  addBuilding: newId => {
    if(newId) {
      dispatch(Actions.addBuilding(newId));
    }
  },
  deleteBuilding: id => dispatch(Actions.deleteBuilding(id)),
  setCurrentBuilding: id => dispatch(Actions.setCurrentBuilding(id)),
  addFacade: (bId, newId) => {
    if(newId) {
      dispatch(Actions.addFacade(bId, newId));
    }
  },
  deleteFacade: (bId, id) => dispatch(Actions.deleteFacade(bId, id)),
  setCurrentFacade: (bId, id) => dispatch(Actions.setCurrentFacade(bId, id)),

  expandAssess: () => dispatch(Actions.expandSection("Assess")), // little sketch, but I'll hard-code it :)
});

class Manage extends Component {
  render() {
    const Lang = this.props.lang.Manage;
    return (
      <Section id="Manage" header={Lang.header}>
        <SubSection>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>{Lang.step1}</Typography>
            </Grid>
            <Grid item xs={4}>
              <MyButton variant="contained" onClick={() => this.props.addBuilding(prompt(Lang.enter_building_name))}>{Lang.add}</MyButton>
            </Grid>
            <Grid item xs={4}>
              <Typography>{Lang.or}</Typography>
            </Grid>
            <Grid item xs={4}>
              <MyButton disabled={!this.props.currentBuildingId} variant="contained" onClick={() => {if(window.confirm(Lang.confirm_delete_building)) {this.props.deleteBuilding(this.props.currentBuildingId)}}}>{Lang.delete}</MyButton>
            </Grid>
            <Grid item xs={12}>
              <Typography>{Lang.select_existing_building}</Typography>
            </Grid>
            <Grid item xs={12} style={{display:"flex",justifyContent:"center"}}>
              <ListPicker header={Lang.building} options={this.props.buildings.map(b => b.buildingId)} val={this.props.currentBuildingId} setVal={id => this.props.setCurrentBuilding(id)}></ListPicker>
            </Grid>
          </Grid>
        </SubSection>
        <SubSection>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography component="div">{Lang.step2} <B text={this.props.currentBuildingId} alt={Lang.current_building}/>:</Typography>
            </Grid>
            <Grid item xs={4}>
              <MyButton disabled={!this.props.currentBuildingId} variant="contained" onClick={() => this.props.addFacade(this.props.currentBuildingId, prompt(Lang.enter_facade_name))}>{Lang.add}</MyButton>
            </Grid>
            <Grid item xs={4}>
              <Typography>{Lang.or}</Typography>
            </Grid>
            <Grid item xs={4}>
              <MyButton disabled={!this.props.currentFacadeId} variant="contained" onClick={() => {if(window.confirm(Lang.confirm_delete_facade)) {this.props.deleteFacade(this.props.currentBuildingId, this.props.currentFacadeId)}}}>{Lang.delete}</MyButton>
            </Grid>
            <Grid item xs={12}>
              <Typography>{Lang.select_existing_facade}</Typography>
            </Grid>
            <Grid item xs={12} style={{display:"flex",justifyContent:"center"}}>
               <ListPicker disabled={!this.props.currentBuildingId} header={Lang.facade} options={this.props.facades.map(f => f.facadeId)} val={this.props.currentFacadeId} setVal={id => this.props.setCurrentFacade(this.props.currentBuildingId, id)}></ListPicker>
            </Grid>
          </Grid>
        </SubSection>
        <SubSection>
          <Typography component="div">
            {Lang.step3} <B text={this.props.currentBuildingId} alt={Lang.current_facade}/>
          </Typography>
          <MyButton disabled={!this.props.currentFacadeId} variant="contained" onClick={this.props.expandAssess}>{Lang.assess}</MyButton>
        </SubSection>
        <SubSection>
          <Typography component="div">
            {Lang.optional_track_collision_rates} <B text={this.props.currentBuildingId} alt={Lang.current_building}/>:
          </Typography>
          <Link url="https://birdmapper.org/app/" text={Lang.global_mapper}/>
        </SubSection>
      </Section>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Manage);



// WEBPACK FOOTER //
// ./src/pages/Manage.js